export const enum GenerateImagesPaycase {
	Subscription = 'subscribe_now',
	Neurons = 'go_to_chat_for_neurons',
	Free = 'go_to_chat_for_free',
}
